<!-- modal lista escogidos -->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="860" scrollable>
      <v-card class="le-card">
        <v-card-title class="le-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-history</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Historial de escogidos</div>
                <div class="text-body-2 white--text">Listas de programas universidad registradas previamente</div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              {{ escogidos.length }} registros
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row dense class="mb-3">
            <v-col cols="12" sm="4" md="3">
              <v-select
                :items="xmeses"
                v-model="input.mes"
                label="Mes"
                item-value="id"
                item-text="text"
                dense
                outlined
                hide-details
                clearable
                prepend-icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                label="Año"
                v-model.number="input.anio"
                dense
                outlined
                hide-details
                clearable
                prepend-icon="mdi-calendar"
                type="number"
              />
            </v-col>
            <v-col cols="12" sm="4" md="3" class="d-flex align-center">
              <v-btn color="teal darken-1" text :loading="loading" @click="listar()">
                <v-icon left>mdi-refresh</v-icon>
                Actualizar
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="xheaders"
            :items="escogidos"
            :loading="loading"
            dense
            class="elevation-1"
            no-data-text="No hay registros para el período seleccionado"
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table" />
            </template>
            <template v-slot:[`item.mes`]="{ item }">
              {{ mesTexto(item.mes) }}
            </template>
            <template v-slot:[`item.fecha_registro`]="{ item }">
              {{ item.fecha_registro ? item.fecha_registro.slice(0, 10) : '—' }}
            </template>
            <template v-slot:[`item.opt`]="{ item }">
              <v-btn small color="teal darken-1" outlined @click="ver_detalle(item)">
                <v-icon small left>mdi-eye</v-icon>
                Detalle
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de detalle -->
    <v-dialog v-model="dialogDetalle" max-width="900" scrollable>
      <v-card v-if="escogidoDetalle">
        <v-card-title class="le-hero py-3">
          <div class="d-flex align-center" style="gap: 10px;">
            <v-icon color="white">mdi-clipboard-list-outline</v-icon>
            <div>
              <div class="text-h6 white--text">{{ escogidoDetalle.nombre_oferta }}</div>
              <div class="text-body-2 white--text">
                {{ mesTexto(escogidoDetalle.mes) }} {{ escogidoDetalle.anio }} · {{ escogidoDetalle.fecha_registro ? escogidoDetalle.fecha_registro.slice(0, 10) : '' }}
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-progress-linear v-if="loadingDetalle" indeterminate color="teal" class="mb-3" />

          <div v-if="!loadingDetalle">
            <div class="text-subtitle-2 mb-2">
              Seleccionados
              <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3 ml-1">
                {{ seleccionadosDetalle.length }}
              </v-chip>
            </div>
            <v-data-table
              :headers="xheaders_det"
              :items="seleccionadosDetalle"
              dense
              disable-pagination
              hide-default-footer
              class="elevation-1 mb-4"
              no-data-text="Sin datos"
            >
              <template v-slot:[`item.ceubArchivoId`]="{ item }">
                <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                  {{ item.ceubArchivoId ? 'si' : 'no' }}
                </v-chip>
              </template>
              <template v-slot:[`item.programas`]="{ item }">
                <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
                  {{ item.programas ? item.programas.length : 0 }}
                </v-chip>
              </template>
              <template v-slot:[`item.estado`]="{ item }">
                <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                  {{ item.estado }}
                </v-chip>
              </template>
            </v-data-table>

            <div class="text-subtitle-2 mb-2">
              Aprobados
              <v-chip x-small color="green lighten-5" class="green--text text--darken-3 ml-1">
                {{ aprobadosDetalle.length }}
              </v-chip>
            </div>
            <v-data-table
              :headers="xheaders_det_aprob"
              :items="aprobadosDetalle"
              dense
              disable-pagination
              hide-default-footer
              class="elevation-1"
              no-data-text="Sin aprobados registrados"
            >
              <template v-slot:[`item.ceubArchivoId`]="{ item }">
                <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                  {{ item.ceubArchivoId ? 'si' : 'no' }}
                </v-chip>
              </template>
              <template v-slot:[`item.programas`]="{ item }">
                <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
                  {{ item.programas ? item.programas.length : 0 }}
                </v-chip>
              </template>
              <template v-slot:[`item.sede`]="{ item }">
                {{ item.sede ? item.sede.nombre || item.sede : '—' }}
              </template>
            </v-data-table>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialogDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { meses } from './utils';

export default {
  data() {
    return {
      dialog: false,
      dialogDetalle: false,
      loading: false,
      loadingDetalle: false,
      escogidos: [],
      escogidoDetalle: null,
      seleccionadosDetalle: [],
      aprobadosDetalle: [],
      xmeses: [],
      xheaders: [
        { text: 'Oferta', value: 'nombre_oferta' },
        { text: 'Mes', value: 'mes' },
        { text: 'Año', value: 'anio' },
        { text: 'Fecha registro', value: 'fecha_registro' },
        { text: '', value: 'opt', sortable: false },
      ],
      xheaders_det: [
        { text: 'Código', value: 'codigo' },
        { text: 'Programa universidad', value: 'programaNombre' },
        { text: 'Sede universidad', value: 'sedeUniversidad' },
        { text: 'CEUB', value: 'ceubArchivoId' },
        { text: 'Programas ESAM', value: 'programas' },
        { text: 'Estado', value: 'estado' },
      ],
      xheaders_det_aprob: [
        { text: 'Código', value: 'codigo' },
        { text: 'Programa universidad', value: 'programaNombre' },
        { text: 'Sede asignada', value: 'sede' },
        { text: 'CEUB', value: 'ceubArchivoId' },
        { text: 'Programas ESAM', value: 'programas' },
      ],
      input: {
        mes: new Date().getMonth(),
        anio: new Date().getFullYear(),
      },
    };
  },
  watch: {
    'input.mes'() { this.listar(); },
    'input.anio'() { this.listar(); },
  },
  methods: {
    mesTexto(mesId) {
      const m = this.xmeses.find(x => x.id === mesId);
      return m ? m.text : mesId;
    },
    async openmodal() {
      this.dialog = true;
      this.xmeses = meses();
      this.input.mes = new Date().getMonth();
      this.input.anio = new Date().getFullYear();
      this.escogidos = [];
      this.listar();
    },
    async listar() {
      const q = {};
      if (this.input.mes !== null && this.input.mes !== undefined && this.input.mes !== '') q.mes = this.input.mes;
      if (this.input.anio) q.anio = this.input.anio;

      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      const graphql = JSON.stringify({
        query: 'query escogidos($q:QueryEscogidos!){ escogidos(q:$q){id seleccionados_por nombre_oferta mes anio fecha_registro} }',
        variables: { q },
      });

      this.loading = true;
      const res = await fetch(process.env.VUE_APP_PROYECTOS_API, { method: 'POST', headers: myHeaders, body: graphql })
        .then(r => r.json()).then(({ data }) => data).catch(e => e);
      this.loading = false;

      if (res && res.escogidos) {
        this.escogidos = res.escogidos;
      }
    },
    async ver_detalle(row) {
      this.escogidoDetalle = row;
      this.seleccionadosDetalle = [];
      this.aprobadosDetalle = [];
      this.dialogDetalle = true;
      this.loadingDetalle = true;

      const q = { anio: row.anio, mes: row.mes };
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      const graphql = JSON.stringify({
        query: 'query escogidos($q:QueryEscogidos!){ escogidos(q:$q){id nombre_oferta mes anio fecha_registro seleccionados aprobados} }',
        variables: { q },
      });

      const res = await fetch(process.env.VUE_APP_PROYECTOS_API, { method: 'POST', headers: myHeaders, body: graphql })
        .then(r => r.json()).then(({ data }) => data).catch(e => e);
      this.loadingDetalle = false;

      if (res && res.escogidos) {
        const item = res.escogidos.find(e => e.id === row.id);
        if (item) {
          this.seleccionadosDetalle = item.seleccionados ? JSON.parse(item.seleccionados) : [];
          this.aprobadosDetalle = item.aprobados ? JSON.parse(item.aprobados) : [];
        }
      }
    },
  },
};
</script>

<style scoped>
.le-card {
  border-radius: 14px;
  overflow: hidden;
}
.le-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
</style>
